import styles from "./NucleappProduct.module.css";
import logo from "../../../assets/nucleapp-logo.svg";

export default function NucleappProduct() {
  return (
    <div className={styles.section}>
      <span>
        A venture from{" "}
        <span className={styles.appContainer}>
          <img className={styles.logoWrapper} alt="" src={logo} />
          NucleApp{" "}
        </span>
        trusted by
      </span>
      <div className={styles.textBlue}>1,00,000+ Users</div>
    </div>
  );
}
